import React, { useEffect, useState } from 'react'
import Layout from './Components/LayoutApplication';
import { UserContext } from './Components/UserContext'
import { LoginSpotify } from './Components/LoginSpotify';
import { SimpleBottomNavigation } from './Components/MusicPlayer';

export const App = () => {

    const [params, setParams] = useState({});

    useEffect(() => {
        getHashParams()
            .then((response) => {
                setParams(response);
            })
    }, [])

    const getHashParams = async () => {
        let hashParams = {};
        let e, r = /([^&;=]+)=?([^&;]*)/g,
            q = window.location.hash.substring(1);
        while ((e = r.exec(q))) {
            hashParams[e[1]] = decodeURIComponent(e[2]);
        }
        return hashParams;
    }

    return (
        <UserContext.Provider value={params.access_token}>
            {params.access_token || params.access_token !== undefined ?
                <>
                    <Layout /> 
                    <SimpleBottomNavigation/>
                </>
                :
                <LoginSpotify />
            }
        </UserContext.Provider>
    )
}